import { TodoAny, ApiFieldError } from 'src/types';
import { actionCreatorFactory } from 'typescript-fsa';

type APIError = ApiFieldError;
type AllLoanApps = TodoAny;

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/ALLLOANAPPS`
);

export const allLoanAppsRequest = actionCreator('request');

export const allLoanAppsRequestSuccess = actionCreator<AllLoanApps>('success');

export const allLoanAppsRequestFail = actionCreator<APIError[]>('fail');

export const updateAdminLoanApps = actionCreator<TodoAny>('loanapp-update');
export const updateMultipleAdminLoanApps = actionCreator<any>(
  'update-multiple-loanApps'
);
